"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.equals = exports.toString = exports.getReferencedProperties = exports.isValidMatchMissing = exports.isValid = exports.isSyntaxValid = exports.fromStringOrEmpty = exports.fromString = exports.Empty = void 0;
var PropertyValue = __importStar(require("./property-value"));
var Ast = __importStar(require("./property-filter-ast/index"));
var _cache = {}; //eslint-disable-line
exports.Empty = {
    text: "",
    ast: Ast.newEmptyExpr(),
    _evaluate: function () { return true; },
};
function create(text, ast) {
    return { text: text, ast: ast, _evaluate: Ast.compileAst(ast) };
}
function fromString(filter, unitLookup) {
    if (filter === null || filter === undefined) {
        throw new Error("Argument 'filter' must be defined.");
    }
    // eslint-disable-next-line no-prototype-builtins
    if (!_cache.hasOwnProperty(filter)) {
        if (filter === "" || filter.trim().length === 0) {
            return exports.Empty;
        }
        var ast = Ast.parse(filter, unitLookup, false);
        if (ast === undefined) {
            console.warn("Invalid property filter syntax: " + filter);
            return undefined;
        }
        _cache[filter] = create(filter, ast);
    }
    return _cache[filter];
}
exports.fromString = fromString;
function fromStringOrEmpty(filterString, unitLookup) {
    var filter = fromString(filterString, unitLookup);
    if (filter === undefined) {
        return exports.Empty;
    }
    return filter;
}
exports.fromStringOrEmpty = fromStringOrEmpty;
function isSyntaxValid(filter, unitLookup, propertyNames) {
    if (propertyNames === void 0) { propertyNames = undefined; }
    if (filter === null || filter === undefined) {
        throw new Error("Argument 'filter' must be defined.");
    }
    if (filter === "" || filter.trim().length === 0) {
        return true;
    }
    var ast = Ast.parse(filter, unitLookup, false);
    if (ast === undefined) {
        return false;
    }
    if (propertyNames === undefined) {
        return true;
    }
    var parsed = create(filter, ast);
    var properties = getReferencedProperties(parsed);
    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
        var p = properties_1[_i];
        if (propertyNames.indexOf(p) === -1) {
            return false;
        }
    }
    return true;
}
exports.isSyntaxValid = isSyntaxValid;
function isValid(properties, filter, comparer) {
    if (comparer === void 0) { comparer = PropertyValue.defaultComparer; }
    return filter._evaluate(properties, comparer);
}
exports.isValid = isValid;
function isValidMatchMissing(properties, filter, comparer) {
    if (comparer === void 0) { comparer = PropertyValue.defaultComparer; }
    if (properties === null || properties === undefined) {
        throw new Error("Argument 'properties' must be defined.");
    }
    if (filter === null || filter === undefined) {
        throw new Error("Argument 'filter' must be defined.");
    }
    return Ast.evaluateAst(filter.ast, properties, true, comparer);
}
exports.isValidMatchMissing = isValidMatchMissing;
function getReferencedProperties(filter) {
    if (filter === null || filter === undefined) {
        throw new Error("Argument 'filter' must be defined.");
    }
    var properties = [];
    Ast.findProperties(filter.ast, properties);
    return properties;
}
exports.getReferencedProperties = getReferencedProperties;
function toString(filter) {
    if (filter === null || filter === undefined) {
        throw new Error("Argument 'filter' must be defined.");
    }
    return filter.text !== null ? filter.text : "";
}
exports.toString = toString;
function equals(other, filter) {
    if (filter === other) {
        return true;
    }
    if (filter === null || filter === undefined) {
        return false;
    }
    if (other === null || other === undefined) {
        return false;
    }
    return other.text === filter.text;
}
exports.equals = equals;
//# sourceMappingURL=property-filter.js.map